import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useField } from 'react-final-form';
export default function FieldError(_ref) {
  let {
    name,
    className
  } = _ref;
  const {
    meta: {
      error,
      submitError,
      submitFailed,
      data
    }
  } = useField(name, {
    subscription: {
      error: true,
      submitFailed: true,
      data: true,
      submitError: true
    }
  });

  if (data !== null && data !== void 0 && data.error) {
    return /*#__PURE__*/React.createElement(FieldErrorMessage, {
      className: className
    }, data === null || data === void 0 ? void 0 : data.error);
  }

  return (error || submitError) && submitFailed ? /*#__PURE__*/React.createElement(FieldErrorMessage, {
    className: className
  }, error || submitError) : null;
}
FieldError.propTypes = {
  name: PropTypes.string.isRequired
};
export function FieldErrorMessage(_ref2) {
  let {
    className,
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("span", {
    className: cx('invalid-feedback', className)
  }, children);
}
export function useFieldError(name) {
  const {
    meta: {
      error,
      submitFailed
    }
  } = useField(name, {
    subscription: {
      error: true,
      submitFailed: true
    }
  });
  return Boolean(error && submitFailed);
}